module.exports = __webpack_public_path__ + "mastercard.eb90ee9bdff61add9416a792477411a3.svg";